export default __webpack_public_path__ + "static/media/Yellow0007.139c35cb.png";